import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import { Size } from '../../common/size';
import { Variant } from '../../common/variant';
import { IThemeProps } from '../../Themes/interfaces';
import { baseFontCss, defaultBoldTextCss } from '../../common/mixins';

// TODO: Move to forms
export const Label = styled.span`
  ${defaultBoldTextCss};
  color: ${({ theme }) => theme.colours.default.text};
  display: flex;
  align-items: center;
`;

export interface ITextBaseProps extends IThemeProps, Pick<CSSProperties, 'textAlign'> {
  variant?: Variant;
  size?: Size;
}

const sizeStyles: Record<Size, ReturnType<typeof css>> = {
  [Size.ExtraSmall]: css`
    font-size: ${({ theme }) => theme.text.sizeExtraSmall};
    line-height: ${({ theme }) => theme.text.lineHeightSmall};
    margin-top: 0.5rem;
  `,
  [Size.Small]: css`
    font-size: ${({ theme }) => theme.text.sizeSmall};
    line-height: ${({ theme }) => theme.text.lineHeightSmall};
    margin-top: 0.5rem;
  `,
  [Size.Medium]: css`
    font-size: ${({ theme }) => theme.text.sizeMedium};
    line-height: ${({ theme }) => theme.text.lineHeight};
    margin: auto;
  `,
  [Size.Large]: css`
    font-size: ${({ theme }) => theme.text.sizeLarge};
    line-height: ${({ theme }) => theme.text.lineHeight};
    margin: auto;
  `,
  [Size.ExtraLarge]: css`
    font-size: ${({ theme }) => theme.text.sizeExtraLarge};
    line-height: ${({ theme }) => theme.text.lineHeight};
    margin-top: 0.5rem;
  `
};

const variantColours: Record<Variant, (props: IThemeProps) => string | undefined> = {
  [Variant.Info]: ({ theme }) => theme.colours.default.text,
  [Variant.Success]: ({ theme }) => theme.colours.yes,
  [Variant.Error]: ({ theme }) => theme.colours.no
};

export const Text = styled.p<ITextBaseProps>`
  ${baseFontCss};
  color: ${({ variant, theme }) => (variant ? variantColours[variant] : theme.colours.default.text)};
  font-style: normal;
  text-align: ${({ textAlign }) => textAlign ?? 'left'};
  ${({ size = Size.Medium }) => sizeStyles[size]}
`;
